import { Router } from 'vue-router'
import { QuestionsStore } from '@/stores/common/questions'

import { routerConstants } from '@/constants/routers/common'
const { PATH } = routerConstants.LOCATION

export const useActions = (store: QuestionsStore, router: Router) => {
  /**
   * 回答選択
   * @param value
   */
  const handleInput = (value: number): void => {
    store.setInputQ3(value)
    router.push(PATH.QUESTIONS_FOUR)
  }

  return {
    handleInput: handleInput,
  }
}
